export default __webpack_public_path__ + "static/media/zukunf_lauft_l3.46371634.png";